const groupRelatedArticles = articles => {
  const filteredArticles = {};
  articles && articles.forEach(article => {
    const tag = article?.fields?.content?.fields?.tags ? article.fields.content.fields.tags[0]?.fields.label : '';
    if (!tag) return;
    if (filteredArticles[tag]) {
      filteredArticles[tag].push(article);
      return;
    }
    filteredArticles[tag] = [article];
  });
  return filteredArticles;
};
export { groupRelatedArticles };
//# sourceMappingURL=groupRelatedArticles.js.map
